import styled from '@emotion/styled'
import { InputLabel, InputLabelProps } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface InputLabelStyledProps extends InputLabelProps {
  inline?: number
  bottom?: number
  required?: boolean
}

export const InputLabelStyled = styled(InputLabel)<InputLabelStyledProps>`
  font-size: ${newTheme.typography.sizes['2xs']};
  font-family: ${newTheme.typography.family.primary};
  font-weight: ${newTheme.typography.weight.lg};
  line-height: normal;
  display: ${({ inline }) => (inline ? 'inline' : 'block')};
  color: ${newTheme.colors.neutral.high};
  ${({ bottom }) =>
    bottom && ` margin-bottom: calc( ${newTheme.spacing.xs} * ${bottom} );`};
`
